// The signed-in user as the screens see it, provided by AuthGate from the Supabase session and api_v1.v_me.
import { createContext, useContext, type ReactNode } from 'react';
import type { Role } from './pages';

export interface Session {
  userId: string;
  role: Role;
  name: string;
}

const SessionContext = createContext<Session | null>(null);

export function SessionProvider({ session, children }: { session: Session; children: ReactNode }) {
  return <SessionContext.Provider value={session}>{children}</SessionContext.Provider>;
}

export function useSession(): Session {
  const s = useContext(SessionContext);
  if (!s) throw new Error('useSession outside SessionProvider');
  return s;
}
